"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSO = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SSO = function SSO() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3C8.4 3 5.455 5.945 5.455 9.545 2.4 9.545 0 11.945 0 15s2.4 5.454 5.455 5.454H18c3.273 0 6-2.727 6-6 0-3.163-2.51-5.781-5.564-6C17.891 5.4 15.273 3 12 3zm5.345 9.366l.483.484a.485.485 0 010 .685l-.857.857a.243.243 0 01-.343 0l-.64-.64a.237.237 0 00-.193-.056l-.017-.017a.364.364 0 00-.257.107l-.603.603a.243.243 0 01-.343 0l-.61-.61a.364.364 0 00-.258-.107h-.178a.364.364 0 00-.257.107l-.247.247a.485.485 0 01-.34.14h-.603a2.666 2.666 0 110-1.94h4.924c.127 0 .249.05.339.14zm-9.423 1.016a.97.97 0 101.902-.379.97.97 0 00-1.902.379z",
    clipRule: "evenodd"
  });
};

exports.SSO = SSO;